import { shippingMethodsOrder } from '~/src/config/dictionary/shippingMethods';

function compareShippingMethodsOrder(shippingMethodCodeA, shippingMethodB) {
    return shippingMethodsOrder.indexOf(shippingMethodCodeA) - shippingMethodsOrder.indexOf(shippingMethodB);
}

export default function (shippingMethods) {
    return [...shippingMethods].sort(({ code: codeA }, { code: codeB }) => compareShippingMethodsOrder(codeA, codeB));
}
